import React from 'react';
import { Calendar as RNCalendar } from 'react-native-calendars';
import { View } from 'react-native';
import { rem } from 'design-system/values';
import { CalendarHeader } from 'design-system/calendar/CalendarHeader';
import { Day } from 'design-system/calendar/Day';
import Spacer from 'design-system/Spacer';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import ContentHeader from './ContentHeader';
import useIsCompactCalendar from './useIsCompactCalendar';
import { isWeb } from '../../constants';
import { FIRST_DAY } from './types';
const WEEK_VERTICAL_MARGIN = 7;
const MAX_WEEKS_IN_MONTH = 6;
const DAY_SIZE = rem(38.5);
const fixedHeightTheme = {
    calendarBackground: 'transparent',
    weekVerticalMargin: WEEK_VERTICAL_MARGIN,
    'stylesheet.calendar.main': {
        monthView: {
            backgroundColor: 'transparent',
            minHeight: MAX_WEEKS_IN_MONTH * (DAY_SIZE + 2 * WEEK_VERTICAL_MARGIN),
        },
    },
};
export const Calendar = React.memo(({ style, hideDays, title = '', reset, blackMonthText, headerStyle, noMarginHorizontal, noPaddingHorizontal, unrestrictedWidth, shouldShowReset = true, fixedHeight, ...props }) => {
    const styles = useStyles(styleSet);
    const compact = useIsCompactCalendar();
    return (<View style={[
            styles.calendarContainer,
            noMarginHorizontal && styles.noMarginHorizontal,
            !noPaddingHorizontal && styles.containerHorizontalPadding,
            !unrestrictedWidth && styles.maxWidth,
        ]}>
        <RNCalendar style={[styles.container, compact && styles.compact, style]} customHeader={(headerProps) => (<>
              {reset ? (<>
                  <ContentHeader title={title} handleReset={reset} shouldShowReset={shouldShowReset}/>
                  <Spacer h={compact ? 8 : 16}/>
                </>) : null}
              <CalendarHeader hideDays={hideDays} headerStyle={headerStyle} blackMonthText={blackMonthText} {...headerProps}/>
            </>)} hideExtraDays theme={fixedHeight
            ? fixedHeightTheme
            : { calendarBackground: 'transparent' }} dayComponent={({ date, state }) => (<Day key={date?.dateString} date={date} isToday={state === 'today'}/>)} firstDay={FIRST_DAY} {...props}/>
      </View>);
});
const styleSet = createStyleSheets((colors) => ({
    container: {
        borderRadius: rem(16),
        paddingBottom: rem(10),
        paddingTop: rem(16),
        ...(!isWeb && {
            width: '100%',
        }),
        backgroundColor: colors.cards.onDark,
    },
    maxWidth: {
        ...(!isWeb && {
            maxWidth: rem(390),
        }),
    },
    containerHorizontalPadding: {
        paddingLeft: rem(16),
        paddingRight: rem(16),
    },
    compact: {
        paddingTop: rem(8),
        paddingBottom: rem(5),
        paddingLeft: rem(10),
        paddingRight: rem(10),
    },
    calendarContainer: {
        overflow: 'hidden',
        marginLeft: rem(16),
        marginRight: rem(16),
        borderRadius: rem(16),
    },
    noMarginHorizontal: {
        marginLeft: 0,
        marginRight: 0,
    },
}));
